import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ContentManagementService } from '../../../Services/content-management/content-management.service';
import { SessionService } from '../../../Services/session.service';
import {
  CoverageRating,
  InsertCoverageRating,
} from '../../../Models/ContentRating';
import { ToastrService } from 'ngx-toastr';
import { AppOfflineStore } from '../../../app.offlineService';
@Component({
  selector: 'app-content-rating',
  templateUrl: './content-rating.component.html',
  styleUrls: ['./content-rating.component.css'],
})
export class ContentRatingComponent implements OnInit {
  @Input() studymateriallist1: any;
  @Output() Closepopup: EventEmitter<any> = new EventEmitter<any>();
  newArray: any;
  Touched: boolean = false;
  constructor(
    public appser: AppOfflineStore,
    public toastr: ToastrService,
    public session: SessionService,
    public service: ContentManagementService
  ) {}

  ngOnInit(): void {
    this.getBreadcrumbDetails();
    this.getRating();
    this.getTopic();

    console.log(
      this.studymateriallist1.Study_Material_Id,
      'studymateriallist1'
    );
  }

  Breadcrumblist: any;
  Breadcrumb: string;
  ID: number;
  getBreadcrumbDetails() {
    this.service
      .getBreadcrumb({
        ID: this.studymateriallist1.Study_Unit_Id,
        Screenname: 'CONTENT_MANAGEMENT',
      })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          this.Breadcrumb = this.Breadcrumblist.Data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getrating: any;
  getRating() {
    this.service.GetCode({ Tablename: 'TOPIC_COVERAGE_RATING_TYPE' }).subscribe(
      (i: any) => {
        this.getrating = i;

        // }).catch((e:any)=>{
        //   this.getstatus=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  gettopic: any;
  response: any;
  TopicList: CoverageRating[] = [];
  getTopic() {
    this.service
      .GetTopicsList({
        LoggedInUserID: this.session.getUser(),
        StudyMaterialID: this.studymateriallist1.Study_Material_Id,
      })
      .subscribe(
        (i: any) => {
          this.response = i;
          this.gettopic = this.response.Data;
          this.StudyMaterialRating();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  studymateriallist: any;
  StudyMaterialRating() {
    this.service
      .GetStudyMaterialRating({
        LoggedInUserID: this.session.getUser(),
        StudyMaterialID: this.studymateriallist1.Study_Material_Id,
        ReportInd: 'N',
      })
      .subscribe(
        (i: any) => {
          this.response = i;
          this.studymateriallist = this.response.Data;
          // for(var j=0;j<this.studymateriallist.length;j++){
          //   this.TopicList.push({
          //     TopicName: this.studymateriallist[j].Topic_Name,
          //     CoverageCommentText: '',
          //     TopicCoverageRatingTypeCode: ''
          //   })
          // }
          for (var x = 0; x < this.gettopic.length; x++) {
            this.TopicList.push({
              TopicName: this.gettopic[x],
              CoverageCommentText: '',
              TopicCoverageRatingTypeCode: '',
            });
          }
          for (var j = 0; j < this.studymateriallist.length; j++) {
            for (var k = 0; k < this.TopicList.length; k++) {
              var newString = this.studymateriallist[j].Topic_Name.replace(
                /\s+/g,
                ' '
              ).trim();
              if (newString == this.TopicList[k].TopicName) {
                this.TopicList[k].CoverageCommentText =
                  this.studymateriallist[j].Coverage_Comment_Text;
                this.TopicList[k].TopicCoverageRatingTypeCode =
                  this.studymateriallist[j].Topic_Coverage_Rating_Type_Code;
              }
            }
          }
          // for(var j=0;j<this.gettopic.length;j++){
          //   this.TopicList.push({
          //     TopicName: this.gettopic[j],
          //     CoverageCommentText: '',
          //     TopicCoverageRatingTypeCode: ''
          //   })
          // }
          // if(this.gettopic!=null){
          //   this.gettopic.map((obj: { Rating: string;Comments:string })=>{
          //     obj.Rating = "";
          //     obj.Comments = "";
          //     return obj;
          //   })
          // }

          console.log(this.studymateriallist, 'studymateriallist');
          // }).catch((e:any)=>{
          //   this.getstatus=null;
          // });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  selectrating(event: any, index: any) {
    this.Touched = true;
    this.TopicList[index].TopicCoverageRatingTypeCode = event.target.value;
  }

  EnterComments(event: any, index: number) {
    this.Touched = true;
    this.TopicList[index].CoverageCommentText = event.target.value;
  }

  Filterlist: any;
  InsertRating: InsertCoverageRating;
  check: boolean;
  InsertResponse: any;
  Save() {
    if (this.Touched) {
      this.check = false;
      for (let item of this.TopicList) {
        if (
          item.TopicCoverageRatingTypeCode == '' &&
          item.CoverageCommentText != ''
        ) {
          this.check = true;
          break;
        }
      }
      if (!this.check) {
        let UDTData: any = [];
        this.Filterlist = this.TopicList.filter(
          (item: {
            CoverageCommentText: string;
            TopicCoverageRatingTypeCode: string;
          }) => item.TopicCoverageRatingTypeCode != ''
        );
        this.Filterlist.forEach(
          (element: {
            TopicName: any;
            CoverageCommentText: any;
            TopicCoverageRatingTypeCode: any;
          }) => {
            let list: any = {};
            list['TopicName'] = element.TopicName;
            list['CoverageCommentText'] = element.CoverageCommentText;
            list['TopicCoverageRatingTypeCode'] =
              element.TopicCoverageRatingTypeCode;
            UDTData.push(list);
          }
        );
        if (UDTData != null) {
          let tempList: InsertCoverageRating;
          tempList = {} as InsertCoverageRating;
          tempList = {
            LoggedInUser: this.session.getUser(),
            SessionLanguageTypeCode: this.appser.MotherTongueLanguage,
            StudyMaterialID: this.studymateriallist1.Study_Material_Id,
            UDTStudyMaterialTopicCoverageRating: UDTData,
          };
          this.InsertRating = tempList;
          this.service.InsertOrUpdateRating(this.InsertRating).subscribe(
            (res) => {
              console.log(res);
              this.InsertResponse = res;
              this.toastr.success('Success!');
              this.Closepopup.emit(1);
              console.log(res);
            },
            (error) => {
              this.toastr.error('Error!' + this.InsertResponse.Message);
            }
          );
        } else {
          this.toastr.error('No data to Save');
        }
      } else {
        this.toastr.error('Please choose Rating for enter comments');
      }
    } else {
      this.toastr.error('No data to Save');
    }
  }

  cancel() {
    this.Closepopup.emit(1);
  }
}
